import React, { useEffect } from 'react';
import { ThemeProvider } from '@emotion/react';
import App from '.';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { chooseTheme, ThemeOptions } from '../theme';
import { CssBaseline } from '@mui/material';
import { callAPISync, updateCustomData } from '../utils/api';
import { updateUserData } from '../store/system/systemSlice';
import { useLogto } from '@logto/react';

const ThemeManager: React.FC = () => {
	const legacyCurrentTheme = useAppSelector((state) => state.user.currentTheme); // to be removed in future
	const userCustomData = useAppSelector((state) => state.system);
	const dispatch = useAppDispatch();
	const logto = useLogto();

	useEffect(() => {
		if (userCustomData.theme === undefined) {
			dispatch(updateUserData({ theme: legacyCurrentTheme as ThemeOptions }));
			callAPISync(logto, (token) => {
				updateCustomData(token, { theme: legacyCurrentTheme as ThemeOptions });
			});
		}
	}, [userCustomData]);

	return (
		<ThemeProvider theme={chooseTheme(userCustomData.theme as ThemeOptions)}>
			<CssBaseline />
			<App />
		</ThemeProvider>
	);
};

export default ThemeManager;
